var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-head",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "Head"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.001,5.378 C0.001,5.378 -0.188,1.177 4.145,0.305 C8.478,-0.567 11.108,1.811 11.495,3.476 C11.882,5.141 12.07,5.994 11.882,6.647 C11.65,6.964 11.727,7.202 12.191,7.995 C12.655,8.788 13.584,9.66 12.268,9.818 C11.417,9.977 11.959,10.531 11.959,10.531 C11.959,10.531 12.191,11.007 11.495,11.086 C11.495,11.086 11.959,11.958 11.572,11.958 C11.185,11.958 11.108,12.117 11.03,12.434 C10.953,12.751 11.107,14.495 8.399,13.464 C7.78,13.147 7.507,14.441 7.161,15.208 C6.953,15.669 6.73,16.298 5.691,15.842 C4.764,15.435 2.696,14.464 1.92,13.137 C1.496,12.41 2.613,11.359 2.071,9.932 C1.529,8.505 1.359,8.945 0.817,8.153 C0.276,7.36 0.079,6.329 0.001,5.378 L0.001,5.378 L0.001,5.378 Z",
    className: "si-glyph-fill"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadIcon);
export default __webpack_public_path__ + "static/media/head-icon.d9909a2916d56599070da7824656716a.svg";
export { ForwardRef as ReactComponent };